import React, { memo, useCallback, useContext, useMemo, useState } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { MODEL_FEEDBACK_CRITERIA, MODEL_FEEDBACK_CRITERIA_WITHOUT_TEXTURES } from 'Pods/ThreeDStudio/constants'
import useOpenedModelReadOnly from 'Pods/ThreeDStudio/Hooks/useOpenedModelReadOnly'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { isEnhancementRun } from 'Pods/ThreeDStudio/Services/isEnhancementRun'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { MATERIAL } from 'Pods/ThreeDStudio/Store/constants'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import FeedbackForm from './Components/FeedbackForm/FeedbackForm'

// "Rate 3D Model" trigger pinned to the viewer's corner that swaps in place for the
// rating form. Only the owner of a plain generation is asked: enhancement runs will get
// a form of their own later, and a user is asked once per campaign.
function ModelFeedback() {
  const t = useTranslation()
  const { modelFeedbackEnabled } = useContext(ThreeDStudioPageContext)
  const openedModel = useThreeDStudioStore(state => state.ui.openedModel)
  const runId = openedModel?.id
  const hasModel = !!openedModel?.outputAssets?.[0]?.fileUrl
  const isEnhancement = useMemo(() => isEnhancementRun(openedModel), [openedModel])
  const isFeedbackSubmitted = useThreeDStudioStore(state => state.ui.isFeedbackSubmitted)
  const isPbr = useThreeDStudioStore(state => state.viewer?.material === MATERIAL.PBR)
  const isReadOnly = useOpenedModelReadOnly()
  // The run the form is open for, so switching models closes it without an effect.
  const [openRunId, setOpenRunId] = useState(null)

  const handleOpen = useCallback(() => setOpenRunId(runId), [runId])
  const handleClose = useCallback(() => setOpenRunId(null), [])

  const isVisible = modelFeedbackEnabled && runId != null && hasModel && !isEnhancement
    && !isReadOnly && !isFeedbackSubmitted
  if (!isVisible) return null

  return (
    <div className="model-feedback">
      {openRunId === runId ? (
        <FeedbackForm
          runId={runId}
          criteria={isPbr ? MODEL_FEEDBACK_CRITERIA : MODEL_FEEDBACK_CRITERIA_WITHOUT_TEXTURES}
          onClose={handleClose}
        />
      ) : (
        <Button
          type="secondary"
          size="tiny"
          actionType="button"
          customClass="model-feedback__trigger"
          aria-expanded={false}
          onClick={handleOpen}
        >
          {t('viewer.modelFeedback.trigger')}
        </Button>
      )}
    </div>
  )
}

export default memo(ModelFeedback)
